module.exports = __webpack_public_path__ + "static/img/zhongBottomNew1.2b2b9a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhongBrand/zhongBottomNew1.png
// module id = HB3V
// module chunks = 0